import { CustomImage } from '@design/models/custom-image.model';

export interface CustomImageState {
  customImage: CustomImage | null;
  isLoading: boolean;
  isCalibrating: boolean;
  calibrationPointsCount: number;  // Number of calibration points placed (0, 1, or 2)
  isEditMode: boolean;  // True when custom image is selected for editing (dragging/rotating enabled)
  showConfirmationDialog: boolean;
  dontShowConfirmationAgain: boolean;
  uploadError: string | null;
  calibrationPending: boolean;
  isMerged: boolean;  // True when custom image has been merged with ground
  preEditSnapshot: CustomImage | null;  // Snapshot of custom image state before entering edit mode
  isNewImage: boolean;  // True if this is a newly uploaded image that hasn't been merged yet
}

export const initialCustomImageState: CustomImageState = {
  customImage: null,
  isLoading: false,
  isCalibrating: false,
  calibrationPointsCount: 0,
  isEditMode: false,
  showConfirmationDialog: false,
  dontShowConfirmationAgain: false,
  uploadError: null,
  calibrationPending: false,
  isMerged: false,
  preEditSnapshot: null,
  isNewImage: false
};
